import _get from 'lodash/get'

/* @ngInject */
export default class EmulatorMotionController {
    constructor(
        EventEmitter,
        $scope,
        $state,
        $timeout,
    ) {
        this.EventEmitter = EventEmitter;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.event = {
            motion: {
                state: _get(this.device, 'reported.motion.state', 'NO_MOTION_DETECTED')
            }
        }
    }

    get prettyState() {
        if (this.event.motion.state === "NO_MOTION_DETECTED") {
            return "No Motion Detected";
        }
        if (this.event.motion.state === "MOTION_DETECTED") {
            return "Motion Detected";
        }
        return "";
    }

    sendMotionEvent() {
        this.onPublishEvent(
            this.EventEmitter({
                event: this.event
            })
        )
    }
}